export function isPartiallyFormattedTelephoneNumber(str: string) {
  // `|$` is a trick to match a partial string
  return /^(\d|$){2}(\s)?(\d|$){2}(\s)?(\d|$){2}(\s)?(\d|$){2}$/.test(str);
}
